// extracted by mini-css-extract-plugin
module.exports = {"all_make_h1":"allMakeManufacture_all_make_h1__W6L9f"};